(($, Drupal) => {
  function closePopup() {
    $(".js-android-popup").removeClass("is-active");
  }

  function openPopup() {
    $(".js-android-popup").addClass("is-active");
  }

  $(document).on("click", ".js-android-popup-close", () => {
    closePopup();
  });

  // Document ready - by jQuery
  $(() => {
    const androidPopupShowed = window.localStorage.getItem(
      "android-popup-showed"
    );
    const isAndroidPopupShowed = parseInt(androidPopupShowed, 10);
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;

    if (!isAndroidPopupShowed && isAndroid) {
      openPopup();
      window.localStorage.setItem("android-popup-showed", "1");
    }
  });

  Drupal.behaviors.android_popup = {
    attach: (/* context, settings */) => {},
  };
})(jQuery, Drupal);
